import { useNavigate } from 'react-router';

import { OneColumn } from 'components/page';
import { useClientContext } from 'context/ClientContext';
import { usePermissionsContext } from 'context/PermissionsContext';
import {
    CarrinhoBbar,
    CarrinhoFinishErrorModal,
    CarrinhoFinishSuccessModal,
    CarrinhoGrid,
    CarrinhoGridFilter,
} from 'pages/compra/carrinho/components';

export function CarrinhoListComp() {
    const { hasPermission } = usePermissionsContext();
    const hasPermissionFinalizacaoGeral = hasPermission(['COMPRA_PEDIDO_FINALIZACAO_GERAL']);
    const navigate = useNavigate();
    const { tipoPedido } = useClientContext();
    const isTipoPedidoPadrao = tipoPedido === 'padrao';
    const isTipoPedidoFuncionario = tipoPedido === 'funcionario';

    return (
        <>
            <CarrinhoFinishSuccessModal />

            <CarrinhoFinishErrorModal />

            <OneColumn
                title="Meu Carrinho"
                goBackButton
                extraButtons={[
                    {
                        title: 'Continuar Comprando',
                        onClick: () => navigate('/compra/pedido'),
                    },
                ]}
            >
                {(isTipoPedidoPadrao || (isTipoPedidoFuncionario && hasPermissionFinalizacaoGeral)) && <CarrinhoGridFilter />}

                <CarrinhoGrid />

                <CarrinhoBbar />
            </OneColumn>
        </>
    );
}
